import http from '../../../utils/fetch';
export default {
    showData(id) {
        return http.post('/api/swyl/v1/demo/productRecord/selectData?id='+id);
    },
    shTG(query) {
        return http({
            url: '/api/swyl/v1/demo/productRecord/auditPass',
            method: 'post',
            params: query
        });
    },
    shBTG(query) {
        return http({
            url: '/api/swyl/v1/demo/productRecord/ReleaseNum',
            method: 'post',
            params: query
        });
    },
}